// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"3d8c8a71","254":"e4554e05","347":"b3d1aadc","472":"33985d73","519":"0809ea94","577":"604045df","606":"0e7955f6","697":"1b1bcd5e","815":"2a6401c9","857":"2583aec2","902":"097e63aa","911":"9f0923e5"}[chunkId] + ".chunk.js";
};